import React from 'react';

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Form,
  CardTitle,
  CardFooter
  
} from 'reactstrap';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";

import {columnsForSAP, columns,customStyles } from "variables/tablecoulmns";

import ModalForm from '../modal/modal'
import MediaQuery from 'react-responsive'

import AuthService from "services/auth.service";

import Timestamp from "react-timestamp";
import Loader from "react-loader-spinner";
import NotificationAlert from "react-notification-alert";


import "./styles.css";
import Tform from '../TicketForms/Tktviewform'

import {PieChart} from "../Chart/index"

//const viewQuery ="SELECT ID,name,class FROM school ";
 class DTable extends React.Component {
   
    constructor(props) {
        super(props);
        let userrole = ''
        if(  AuthService.getCurrentUser().roles.includes('ROLE_HELPDESK')){userrole = 'HelpDesk'}
       else if(  AuthService.getCurrentUser().roles.includes('ROLE_SYSTEM')){userrole = 'System'}
       else if(  AuthService.getCurrentUser().roles.includes('ROLE_NETWORK')){userrole = 'Network'}
       else if(  AuthService.getCurrentUser().roles.includes('ROLE_SAP')){userrole = 'SAP'}
      
      
       let startDate = new Date();
       let endDate = new Date();
       startDate.setDate(startDate.getDate() - 30);

       endDate.setDate(endDate.getDate());

       let sdate = startDate.toISOString().substr(0,10);
       
       let edate = endDate.toISOString().substr(0,10);


        this.state = {
            viewdata:[
              {
                  "id": 22551,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "Not Updated",
                  "description": "can't logon SAP ",
                  "queue": "SAP",
                  "category": "BASIS",
                  "sub": "User Account Troubleshooting",
                  "state": "Completed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "test.user",
                  "sapreqnum": "",
                  "site": "Site2",
                  "resolution": "true",
                  "ipadd": "50.50.113.131",
                  "createdAt": "2022-02-28T12:40:19.000Z",
                  "updatedAt": "2022-02-28T13:23:09.000Z"
              },
              {
                  "id": 22550,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "Maintainance",
                  "description": "Kindly issue a Laptop case\nregards",
                  "queue": "HelpDesk",
                  "category": "SAP Reservation",
                  "sub": "Create Reservation",
                  "state": "Pending",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "test.user",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "false",
                  "ipadd": "50.50.50.152",
                  "createdAt": "2022-02-28T12:31:07.000Z",
                  "updatedAt": "2022-02-28T12:39:21.000Z"
              },
              {
                  "id": 22549,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "purchasing",
                  "description": "I created 2 POs 100017181 & 100017182 and I can't find the release status tab",
                  "queue": "SAP",
                  "category": "Material Management (MM)",
                  "sub": "User Support",
                  "state": "Waiting For User",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "test.user",
                  "sapreqnum": "",
                  "site": "Site2",
                  "resolution": "true",
                  "ipadd": "50.50.109.12",
                  "createdAt": "2022-02-28T12:26:33.000Z",
                  "updatedAt": "2022-02-28T12:32:32.000Z"
              },
              {
                  "id": 22548,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "Non-Updated",
                  "description": " i need open usb to transfer data\nDirector approval attached",
                  "queue": "HelpDesk",
                  "category": "Computer",
                  "sub": "Enable USB Access",
                  "state": "Completed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "test.agent",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.50.13",
                  "createdAt": "2022-02-28T11:33:46.000Z",
                  "updatedAt": "2022-02-28T11:38:57.000Z"
              },
              {
                  "id": 22547,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "Non-Updated",
                  "description": "Need to reset email.",
                  "queue": "HelpDesk",
                  "category": "Email",
                  "sub": "Reset Password",
                  "state": "Completed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "test.user",
                  "sapreqnum": "None",
                  "site": "Site3",
                  "resolution": "true",
                  "ipadd": "50.50.128.126",
                  "createdAt": "2022-02-28T11:06:46.000Z",
                  "updatedAt": "2022-02-28T11:10:28.000Z"
              },

              {
                  "id": 22545,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "Non-Updated",
                  "description": "I can't print",
                  "queue": "HelpDesk",
                  "category": "Printer",
                  "sub": "Printing Unavailable",
                  "state": "Completed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "test.agent",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.50.13",
                  "createdAt": "2022-02-28T09:25:39.000Z",
                  "updatedAt": "2022-02-28T09:26:11.000Z"
              },
              {
                  "id": 22544,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "Civil",
                  "description": "Need SAP Assistance ",
                  "queue": "SAP",
                  "category": "Material Management (MM)",
                  "sub": "User Support",
                  "state": "Waiting For User",
                  "slares": "Violated",
                  "actsla": "Achieved",
                  "author": "test.user",
                  "sapreqnum": "",
                  "site": "Site5",
                  "resolution": "true",
                  "ipadd": "50.50.17.179",
                  "createdAt": "2022-02-28T08:44:46.000Z",
                  "updatedAt": "2022-02-28T13:52:35.000Z"
              }
          ],
            loading:false,
            selectedRows: [],
            isOpen: false,
            queue:'All',
            state:'All',
            site:'All',
            agent:'All',
            category:'All',
            sub:'All',
            startdate:sdate,
            enddate:edate,
            Chartcontrol:'Queue',
            Chartcontrols:['Queue' , 'Agent' ,'Site', 'Category' , 'Sub' ,'State' , 'Response SLA'],
            chartdata :  [
              {
                  "label": "HelpDesk",
                  "count": 98,
                  "y": "35.8"
              },
              {
                  "label": "SAP",
                  "count": 41,
                  "y": "15.0"
              },
              {
                  "label": "Network",
                  "count": 27,
                  "y": "9.9"
              },
              {
                  "label": "System",
                  "count": 108,
                  "y": "39.4"
              }
          ],
            qusers:[
              {
                  "refname": "test.agent"
              },

          ],
            formcatgs:[
              {
                  "refsub": "Active Directory"
              },
              {
                  "refsub": "Health Check"
              },
              {
                  "refsub": "System Services"
              },
              {
                  "refsub": "Group Policy"
              },
              {
                  "refsub": "File Server"
              },
              {
                  "refsub": "WSUS"
              },
              {
                  "refsub": "SCCM"
              },
              {
                  "refsub": "Print Management"
              },
              {
                  "refsub": "Attendance Systems"
              },
              {
                  "refsub": "Terminal Server"
              },
              {
                  "refsub": "Backup Mangement"
              },
              {
                  "refsub": "Vmware Management"
              },
              {
                  "refsub": "Server Hardware Management"
              },
              {
                  "refsub": "DataCenter"
              },
              {
                  "refsub": "Mail Services"
              },
              {
                  "refsub": "Antivirus"
              },
              {
                  "refsub": "Applications"
              },
              {
                  "refsub": "Configuration Backup"
              },
              {
                  "refsub": "Other"
              }
          ],
            formsubcats:[],
            isomits:window.innerWidth <= 1600 

            


        };

      }


      notify = (typee , msg) => {
        var options = {};
        options = {place: 'tc',message: (<div><div> {msg}</div></div>  ),type: typee,icon: "now-ui-icons ui-1_bell-53",autoDismiss: 7,}
        this.refs.notificationAlert.notificationAlert(options);
      }
    


//****************************start form control****************************** */






          







//****************************End form control****************************** */









 componentDidMount() {




}

componentWillUnmount(){

}






 
 handleButtonClick = (state) => {
    //alert('action Clicked for Row Number'+ state.target.id);
    this.setState({ isOpen: true , targetid: state.target.id});
  };
  handleChange = state => {
    console.log('state', state.selectedRows);

    this.setState({ selectedRows: state.selectedRows });
  };








  handleFilterChange = (e) =>{ 
  

    let Filterpromise = new Promise((myResolve, myReject) =>{ 
    
    // The producing code (this may take some time)
    this.setState({[e.target.name]: e.target.value})
  
  
        myResolve(e.target.name);
        myReject("Error");
      
  
  
  
  
    });
    
    Filterpromise.then(
      (value)  =>{
        const startdate = new Date(this.state.startdate);
        const enddate = new Date(this.state.enddate);
           
if (startdate > enddate) {this.notify('danger' , 'Start Date Must Be Before End Date')}


if (value === 'queue') {this.setState({category: "All",sub: "All"});   ;
     
}

if (value === 'category') {this.setState({sub: "All"});}

let CnewControls = []
if (this.state.queue === 'All') {CnewControls.push('Queue')}
if (this.state.agent === 'All') {CnewControls.push('Agent')}
if (this.state.category === 'All') {CnewControls.push('Category')}
if (this.state.sub === 'All') {CnewControls.push('Sub')}
if (this.state.state === 'All') {CnewControls.push('State')}
if (this.state.site === 'All') {CnewControls.push('Site')}

CnewControls.push('Response SLA')
this.setState({Chartcontrols:CnewControls,Chartcontrol:CnewControls[0]})

if (CnewControls.length === 0 ) {this.setState({Chartcontrols:['Queue'] , Chartcontrol:'Queue'})
}






      },
      (error)  =>{}
    );
    
    
    
  
  //handleChange = (e) =>{ this.setState({[e.target.name]: e.target.value})
  
  
  }

  handleChartChange = (e) =>{ 
  

    let Filterpromise = new Promise((myResolve, myReject) =>{ 
    
    // The producing code (this may take some time)
    this.setState({[e.target.name]: e.target.value})
  
  
  
        myResolve(e.target.name);
        myReject("Error");
      
  
  
  
  
    });
    
    Filterpromise.then(
      (value)  =>{




       },
      (error)  =>{}
    );
    
    
    
  
  //handleChange = (e) =>{ this.setState({[e.target.name]: e.target.value})
  
  
  }













  openModal = () => this.setState({ isOpen: true });
  closeModal = () => {this.setState({ isOpen: false ,targetid:''});}





  render(){
    let data = this.state.viewdata
    const tableData = {
      columns,
      data
    };

    let chartlabel = 'Grouped By ' + this.state.Chartcontrol

    const categories = this.state.formcatgs.map(cat =><option key={cat.refsub}>{cat.refsub}</option>
      )


      const subcats = this.state.formsubcats.map(cat =><option key={cat.refname}>{cat.refname}</option>
        )

        const qusrs = this.state.qusers.map(user =><option key={user.refname}>{user.refname}</option>
          )

          const Chartcontrols = this.state.Chartcontrols.map(user =><option key={user}>{user}</option>
            )
  

            let coulmstoview = this.state.queue === 'SAP' ? columnsForSAP(this.handleButtonClick , this.state.isomits) : columns(this.handleButtonClick, this.state.isomits);


  return (
<div>
{ this.state.loading ? 
  <Row className="justify-content-center align-items-center" >

<Loader
        type="Puff"
        color="rgb(101, 153, 57)"
        height={150}
        width={150}
        timeout={15000} //3 secs
      /></Row>
:
<div>
<NotificationAlert ref="notificationAlert" />

<Row className="justify-content-center align-items-center">
            <Col md={6} sm={12}>
              <Card>

              <CardBody className="all-icons">
               <PieChart  label={chartlabel} data={this.state.chartdata}  theme={"light1"}/>

               <Label for="exampleSdccaelect">Chart Control (Group By {this.state.Chartcontrol})</Label>
          <Input  type="select" name="Chartcontrol" id="exampleSelectasdasd" onChange={this.handleChartChange}  value={this.state.Chartcontrol}  >
         {Chartcontrols}

          </Input>
                </CardBody>
              </Card>
            </Col>

          </Row>


<CardHeader>
                  <h5 className="title">Please Choose Reporting Criteria</h5>

                </CardHeader>

<Form>

      <FormGroup>
        <Row>





        <Col xs={12} md={3}>
          <Label for="exampleSelescascact">Queue</Label>
          <Input type="select" name="queue" id="exampleSelescascact" onChange={this.handleFilterChange}  value={this.state.queue}>
          <option>All</option>
          <option>IT Service Team</option>

            <option>HelpDesk</option>
            <option>Systems</option>
            <option>Network</option>
            <option>SAP</option>
          </Input>
          </Col>

          <Col xs={12} md={3}>
          <Label for="exampleSelecascascct">State</Label>
          <Input type="select" name="state" id="exampleSelecascascct" onChange={this.handleFilterChange}  value={this.state.state}>
            <option>All</option>
            <option>Open</option>
            <option>In Progress</option>
            <option>Waiting For User</option>
            <option>Pending</option>
            <option>Completed</option>
            <option>Closed</option>
               
          </Input>
          </Col>

          <Col xs={12} md={3}>
          <Label for="examplqwdqqweSelect">agent</Label>
          <Input type="select" name="agent" id="examplqwdqqweSelect" onChange={this.handleFilterChange}  value={this.state.agent}>
          <option>All</option>
            {qusrs}
            <option>Non-Assigned</option>

          </Input>
          </Col>


          <Col xs={12} md={3}>
  <Label for="exampsdadaleqSelect">Category</Label>
  <Input type="select" name="category" id="exampsdadaleqSelect" onChange={this.handleFilterChange}  value={this.state.category}>
  <option>All</option>
    {/*<option>Printer</option>
    <option>Computer</option>
    <option>Network</option>
    <option>SAP</option>
    <option>System</option>*/}
{categories}
  </Input>
  </Col>


          </Row>

<br></br>
          <Row>







  <Col xs={12} md={3}>
  <Label for="examplexsxscelect">Sub-Category</Label>
  <Input type="select" name="sub" id="exampleSxsxscelect" onChange={this.handleFilterChange}  value={this.state.sub}>
    <option>All</option>
{subcats}

  </Input>
  </Col>



  <Col xs={12} md={3}>
  <Label for="examsdajjkpleSelect">Site</Label>
  <Input type="select" name="site" id="examsdajjkpleSelect" onChange={this.handleFilterChange}  value={this.state.site}>
  <option>All</option>

    <option>Site1</option>
    <option>Site5</option>
    <option>Site3</option>
    <option>Site2</option>
    <option>Site4</option>

  </Input>
  </Col>


  <Col xs={12} md={3}>
  <Label for="examplessasuuSelect">Start Date</Label>
  <Input type="date" name="startdate" id="examplessasuuSelect" onChange={this.handleFilterChange}  value={this.state.startdate}>

  </Input>
  </Col>

  <Col xs={12} md={3}>
  <Label for="exampleSessffsdfslect">End Date</Label>
  <Input type="date" name="enddate" id="exampleSessffsdfslect" onChange={this.handleFilterChange}  value={this.state.enddate}>

  </Input>
  </Col>


  </Row>



</FormGroup>
</Form>









<MediaQuery minDeviceWidth={1244}>


      <DataTableExtensions columns={coulmstoview}  data={data} exportHeaders print={false} filterPlaceholder="Search">


                <DataTable

                data={this.state.viewdata}
                
                columns={coulmstoview}
                onRowSelected={this.handleChange}
              customStyles={customStyles}
                //  style={{maxWidth:'500px'}}
                pagination
                paginationPerPage={20}
                paginationRowsPerPageOptions={[10, 20, 50, 100  ]	}
                selectableRows
                responsive
                highlightOnHover
                striped
                noHeader = {this.state.isomits}

                />

                      </DataTableExtensions>
</MediaQuery>

<MediaQuery maxDeviceWidth={1244} >
<Row >
     {this.state.viewdata.map((tkt) => {
      return (
    
    
            <Col xs={12} md={4}
          
          key={tkt.id} >
 
    <Card  style={{ boxShadow: '  0 0 5px gray,  0 0 20px gray,  0 0 5px gray',
}}>
                <CardHeader  className="text-center">
                  <CardTitle tag="strong" style={{color:"green"}}>Ticket# {tkt.id} - {tkt.sub}</CardTitle>
<hr/>
                </CardHeader>



                <CardBody>
<ul style={{color:"rgb(65,70,75)"}}>
<li><strong>Client:</strong> {tkt.client}</li>

<li><strong>Status:</strong> {tkt.state}</li>
<li><strong>Category:</strong> {tkt.category}</li>

<li><strong>Sub-Category:</strong> {tkt.sub}</li>
<li><strong>Created:</strong> <Timestamp relative date={tkt.createdAt} autoUpdate /></li>
<li><strong>Last Update:</strong> <Timestamp relative date={tkt.updatedAt} autoUpdate /></li>



</ul>

                </CardBody>



                <CardFooter className="text-center" >
                <hr/>

                <Button onClick={this.handleButtonClick} id={tkt.id} style={{backgroundColor:'rgb(101, 153, 57)'}  } >View/Edit</Button>
                </CardFooter>
              </Card>

              


          </Col>
       
      );
    })}
    
    
    </Row>

</MediaQuery>






                      </div>
}
        { this.state.isOpen ? 
          <ModalForm 
            closeModal={this.closeModal} 
            isOpen={this.state.isOpen} 
            title={"Ticket# " + this.state.targetid}
            hoste={<Tform tktid={this.state.targetid}></Tform>}
            size="lg"
          /> 
          : 
          null 
        }








</div>

  );
}
}
export default DTable;
